<template>
  <div>
    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
          <h1>
            Historial de cambios - Servicio
            <el-select
              v-model="service"
              @change="filter"
              placeholder="Select"
              filterable
            >
              <el-option
                v-for="item in services"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            Código postal
            <el-input
              v-model="code"
              @change="filter"
              class="postalcode"
              autocomplete="off"
              clearable
              maxlength="5"
            >
            </el-input>
          </h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->

    <!-- Table Logs -->
    <el-row>
      <el-col :span="20" :offset="2">
        <el-card class="box-card">
          <el-table
            :data="history"
            style="width: 100%"
            :default-sort="{ prop: 'date', order: 'descending' }"
            stripe
          >
            <el-table-column
              label="Autor"
              prop="author"
              align="center"
              sortable
            >
              <template slot-scope="props">
                <h4>
                  <i class="el-icon-user"></i>
                  {{ props.row.author }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Ubicación"
              prop="address"
              align="center"
              sortable
            >
              <template slot-scope="props">
                <h4>
                  <i class="el-icon-user"></i>
                  {{ props.row.address.country }} -
                  {{ props.row.address.state }} - {{ props.row.address.city }} -
                  {{ props.row.address.postalCode }} -
                  {{ props.row.address.sector }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Servicio"
              prop="service"
              align="center"
              sortable
            >
              <template slot-scope="props">
                <h4>
                  <i class="el-icon-user"></i>
                  {{ props.row.service.countryCode }} -
                  {{ props.row.service.carrierName }} -
                  {{ props.row.service.serviceType }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Deshabilitado"
              prop="disabled"
              align="center"
              sortable
            >
              <template slot-scope="props">
                <h4>
                  <i class="el-icon-user"></i>
                  {{ props.row.disabled || "Ningúno" }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column label="Cambios" align="center">
              <template slot-scope="props">
                <div v-if="verifyType(props.row.changes)">
                  <h4 class="change-item">{{ props.row.changes }}</h4>
                </div>
                <div
                  v-else
                  v-for="(value, key) in props.row.changes"
                  :key="key"
                >
                  <h4 class="change-item" v-if="key !== 'disabled'">
                    {{
                      {
                        isOcurre: "Ocurre",
                        days: "Días",
                        outOfArea: "Fuera del área",
                        outOfPickup: "Fuera de Pickup",
                        covered: "Cobertura",
                      }[key]
                    }}: {{ value }}
                  </h4>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Fecha" align="center" prop="date" sortable>
              <template slot-scope="props">
                <i class="el-icon-time"></i>
                {{ props.row.date | formatDate }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <!-- END Table Logs -->
    <br />
  </div>
</template>

<script>
import DialogUser from "@/components/DialogUser";
import { CSApi } from "@/libraries/api";

export default {
  name: "History",
  components: {
    DialogUser,
  },
  data() {
    return {
      history: [],
      services: [],
      service: "All",
      code: "",
    };
  },
  methods: {
    async logHistory() {
      try {
        let params = "";

        if (this.service !== "All") {
          params += `service=${this.service}&`;
        }

        if (this.code !== "") {
          params += `postalCode=${this.code}&`;
        }

        const response = await CSApi().get(
          `/coverage/history?${params}page=1&pageSize=500`
        );
        const { data } = response.data;
        this.history = data;
      } catch (error) {
        console.log(error.response);
        this.$message({
          message: error,
          type: "error",
          duration: 8000,
        });
      }
    },
    async filter() {
      const query = {
        servie: this.service,
        code: this.code,
      };
      this.$router.replace({ query });

      await this.logHistory();
    },
    verifyType(val) {
      return typeof val == "string";
    },
  },
  async mounted() {
    await this.logHistory();

    const response = await CSApi().get(
      `coverage/service?searchBy=&page=1&pageSize=500`
    );

    const { data } = response.data;

    this.services = [];

    this.services.push({
      value: "All",
      label: "All",
    });

    const correctServices = data.filter(
      (service) => service.countryCode == "MX"
    );

    for (const service of correctServices) {
      const key = `${service.carrier} / ${service.service}`;

      this.services.push({ value: service.uuid, label: key });
    }
  },
};
</script>

<style scoped>
.el-timeline {
  overflow-y: auto;
  height: 100vh;
  padding-top: 20px;
}

.change-item {
  margin-bottom: 2px;
  margin-top: 2px;
}

pre {
  margin: 0px 30px;
}
.el-select {
  width: 230px;
}
.postalcode {
  display: inline-block !important;
  position: relative !important;
  width: 100px !important;
}
</style>
